import { AnalyticsEvent } from '../models';

export class ProductViewEvent implements AnalyticsEvent {
  name = 'ProductViewEvent';
  constructor(public readonly productName: string) {}
}
